(() => {
  'use strict';
  if (window.AWContextualUniverse?.version) return;

  const CONTEXTS = {
    all: { label:'Toute la boutique', shortLabel:'la boutique', home:'/', eyebrow:'Explorer la boutique', title:'Que recherchez-vous ?', placeholder:'Produit, catégorie, univers…', links:[] },
    replicas: { label:'Répliques Airsoft', shortLabel:'les Répliques', home:'/pages/repliques-airsoft', eyebrow:'Explorer les Répliques Airsoft', title:'Quelle réplique recherchez-vous ?', placeholder:'AEG, GBBR, réplique de poing, sniper, HPA…', links:[['AEG','/collections/repliques-airsoft-aeg'],['GBBR','/collections/repliques-airsoft-gbbr'],['Répliques de poing','/collections/repliques-de-poing-airsoft'],['Compatibilité','/pages/compatibilite-airsoft']], keywords:['replique','aeg','gbbr','gbb','aep','sniper','spring','fusil','pistolet','carabine'] },
    parts: { label:'Pièces & accessoires', shortLabel:'les Pièces & accessoires', home:'/pages/accessoires-repliques', eyebrow:'Explorer les Pièces & accessoires', title:'Que recherchez-vous pour votre réplique ?', placeholder:'Hop-Up, moteur, gearbox, optique, chargeur, rail…', links:[['Pièces internes AEG','/collections/replique-airsoft-aeg-pieces-internes'],['Optiques','/collections/accessoires-repliques-airsoft-optiques'],['Compatibilité','/pages/compatibilite-airsoft']], keywords:['hop-up','hopup','gearbox','moteur','nozzle','piston','canon','joint','bucking','nub','mosfet','etu','optique','viseur','chargeur','rail','montage','silencieux','traceur','ressort','engrenage'] },
    equipment: { label:'Équipement & protection', shortLabel:'l’Équipement', home:'/pages/equipements-airsoft-1', eyebrow:'Explorer l’Équipement Airsoft', title:'Quel équipement recherchez-vous ?', placeholder:'Protection, casque, gilet, holster, poche, bagagerie…', links:[['Tout l’équipement','/collections/equipements-airsoft'],['Protection','/collections/equipements-airsoft-protection-oculaire-lunettes'],['Holsters','/collections/equipements-airsoft-holsters']], keywords:['equipement','protection','casque','gilet','holster','poche','pouch','bagagerie','sac','housse','gant','ceinture','lunette','masque','ghillie','sangle'] },
    consumables: { label:'Consommables Airsoft', shortLabel:'les Consommables', home:'/pages/consommables-airsoft', eyebrow:'Explorer les Consommables Airsoft', title:'Quel consommable recherchez-vous ?', placeholder:'Billes BIO, gaz, entretien, fumigène…', links:[['Billes BIO','/collections/consommables-airsoft-billes-6mm-bio'],['Gaz','/collections/consommables-airsoft-gaz'],['Entretien','/collections/consommables-airsoft-entretien']], keywords:['bille','bb','gaz','co2','fumigene','entretien','lubrifiant','huile','graisse','cartouche'] },
    hpa: { label:'Airsoft HPA', shortLabel:'le HPA', home:'/collections/repliques-airsoft-hpa', eyebrow:'Explorer l’univers HPA', title:'Que recherchez-vous pour votre configuration HPA ?', placeholder:'Réplique HPA, régulateur, flexible, moteur, raccord…', links:[['Répliques HPA','/collections/repliques-airsoft-hpa'],['Pièces & accessoires','/pages/accessoires-repliques'],['Compatibilité','/pages/compatibilite-airsoft']], keywords:['hpa','polarstar','wolverine','airtac','regulateur','regulator','flexible','raccord','engine','moteur hpa','bouteille','reservoir'] },
    workshop: { label:'Atelier Airsoft', shortLabel:'l’Atelier', home:'/pages/notre-atelier-de-preparation-de-repliques-airsoft', eyebrow:'Explorer l’Atelier Airsoft', title:'Quel service ou besoin Atelier recherchez-vous ?', placeholder:'Révision, diagnostic, montage, Hop-Up, MOSFET…', links:[['Prestations','/collections/atelier-airsoft'],['Mon Atelier','/pages/mon-atelier-airsoft'],['Compatibilité','/pages/compatibilite-airsoft']], keywords:['atelier','forfait','revision','entretien','diagnostic','montage','installation','preparation','reglage','shimming','mosfet','etu','hop-up'] },
    compatibility: { label:'Compatibilité Airsoft', shortLabel:'la Compatibilité Airsoft', home:'/pages/compatibilite-airsoft', eyebrow:'Explorer la Compatibilité Airsoft', title:'Quelle pièce, plateforme ou réplique recherchez-vous ?', placeholder:'M4, AK, Glock, Hi-Capa, Scorpion EVO, pièce…', links:[['Répliques','/pages/repliques-airsoft'],['Pièces & accessoires','/pages/accessoires-repliques'],['Atelier','/pages/notre-atelier-de-preparation-de-repliques-airsoft']], keywords:['compatibilite','plateforme','m4','ar15','ak','glock','hi-capa','hicapa','scorpion','hk416','mp5','g36','sr25','scar','vsr','p90'] },
    guides: { label:'Guides Airsoft', shortLabel:'les Guides Airsoft', home:'/pages/blog', eyebrow:'Explorer les Guides Airsoft', title:'Quel sujet Airsoft voulez-vous approfondir ?', placeholder:'AEG, HPA, Hop-Up, moteur, entretien, protection…', links:[['Guide Airsoft','/blogs/guide-complet-airsoft-debuter'],['Compatibilité','/pages/compatibilite-airsoft'],['Atelier','/pages/notre-atelier-de-preparation-de-repliques-airsoft']], keywords:['guide','choisir','comparatif','comparaison','entretien','reglage','upgrade','optimisation','debuter','comprendre'] },
    'assassins-creed': { label:"Assassin's Creed", shortLabel:"Assassin's Creed", home:'/pages/assassins-creed', eyebrow:"Explorer Assassin's Creed", title:"Que recherchez-vous dans l’univers Assassin's Creed ?", placeholder:'Lame secrète, décoration, figurine, vêtement…', links:[['Lames secrètes','/collections/assassins-creed-lame-secrete-hidden-blade'],['Accessoires','/collections/assassins-creed-accessoires'],['Guides & lore','/blogs/assassins-creed']], keywords:['assassin','creed','hidden blade','lame secrete','ezio','altair','connor','edward','arno','figurine'] },
    parkour: { label:'Parkour', shortLabel:'le Parkour', home:'/pages/parkour', eyebrow:'Explorer le Parkour', title:'Que recherchez-vous pour votre pratique ?', placeholder:'Vêtement, chaussure, équipement, guide…', links:[['Équipement Parkour','/collections/equipement-parkour'],['Guides Parkour','/blogs/parkour'],['Tous les guides','/pages/blog']], keywords:['parkour','freerun','jogging','pantalon','chaussure','t-shirt'] },
    youtube: { label:'Création & YouTube', shortLabel:'la création & YouTube', home:'/pages/setup-youtube', eyebrow:'Explorer la création & YouTube', title:'Que recherchez-vous pour filmer ou créer ?', placeholder:'Caméra, support, accessoire, guide…', links:[['Guides vidéo','/blogs/youtube'],['Tous les guides','/pages/blog'],['Airsoft','/pages/repliques-airsoft']], keywords:['youtube','video','camera','gopro','support','micro','filmer','tournage'] }
  };

  const PLATFORMS = {
    'm4-ar15':['M4 / AR15',['m4','ar15','ar-15','m16','stanag']], 'ak':['AK',['ak','ak47','ak-47','ak74','ak-74','aks']], 'mp5':['MP5',['mp5']], 'g36':['G36',['g36']], 'hk416':['HK416',['hk416','hk 416','hk-416']],
    'cz-scorpion-evo':['CZ Scorpion EVO',['cz scorpion','scorpion evo','evo 3','cz evo']], 'glock':['Glock',['glock','g17','g18','g19','g23','g26','g34']], 'hi-capa':['Hi-Capa',['hi-capa','hi capa','hicapa','2011']],
    'sr25-m110':['SR25 / M110',['sr25','sr-25','m110']], 'scar':['SCAR',['scar','scar-l','scar-h','scar sc']], 'l96-aw308':['L96 / AW308',['l96','aw308','aw 308']], 'vsr-10':['VSR-10',['vsr','vsr-10','vsr 10']],
    'p90':['P90',['p90']], 'aug':['AUG',['aug']], 'm14':['M14',['m14']], 'm249':['M249',['m249']], 'sig-mpx':['SIG MPX',['sig mpx','mpx']], 'famas':['FAMAS',['famas']], 'aap-01':['AAP-01',['aap-01','aap01','aap 01']],
    'spas-12':['SPAS-12',['spas-12','spas 12']], 'm3-shotgun':['M3 Shotgun',['m3 shotgun','m3 super 90','benelli m3']], 'm870-shotgun':['M870 Shotgun',['m870','870 shotgun','remington 870']],
    'aw-custom-vx9':['AW Custom VX9',['aw custom vx9','vx9']], 'wolverine-mtw-9':['Wolverine MTW-9',['wolverine mtw','mtw-9','mtw 9']], 'sig-55x':['SIG 550 / 551 / 552',['sig 550','sig 551','sig 552','sig55','sig 55']],
    'kj-works-kp-series':['KJ Works KP-13 / KP-17 / KP-18',['kp-13','kp13','kp-17','kp17','kp-18','kp18','kj works kp']], 'g3':['G3',['g3']], 'sig-p320':['SIG P320',['sig p320','p320','m17','m18']],
    'sig-p22x':['SIG P220 / P225 / P226 / P228 / P229',['p220','p225','p226','p228','p229','sig p22']], 'beretta-92-m9':['Beretta 92 / M9',['beretta 92','m9','m92','92fs']],
    'cz-p07-p09':['CZ P-07 / P-09',['cz p-07','cz p07','p-07','p07','cz p-09','cz p09','p-09','p09']], 'taurus-pt92-nbb':['Taurus PT92 NBB',['taurus pt92 nbb','pt92 nbb','pt92-nbb']],
    'taurus-pt92-spring':['Taurus PT92 Spring',['taurus pt92 spring','pt92 spring','pt92-spring']], 'm1911':['M1911',['m1911','1911']], 'secutor-velites':['Secutor VELITES',['secutor velites','velites']],
    'cz-shadow-2':['CZ Shadow 2',['cz shadow 2','shadow 2','shadow2']], 'smith-wesson-mp':['Smith & Wesson M&P',['smith wesson','smith & wesson','m&p','m and p']]
  };

  const normalize = (v='') => String(v).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/&/g,' et ').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  const params = new URL(location.href).searchParams;
  const source = document.querySelector('[data-aw-universe-context]');
  const requestedKey = normalize(params.get('aw_universe') || '');
  const sourceKey = normalize(source?.dataset.key || 'all');
  const key = CONTEXTS[requestedKey] ? requestedKey : (CONTEXTS[sourceKey] ? sourceKey : 'all');
  const base = CONTEXTS[key] || CONTEXTS.all;
  const context = source && key === sourceKey ? { ...base, label:source.dataset.label||base.label, shortLabel:source.dataset.shortLabel||base.shortLabel, home:source.dataset.home||base.home, eyebrow:source.dataset.searchEyebrow||base.eyebrow, title:source.dataset.searchTitle||base.title, placeholder:source.dataset.searchPlaceholder||base.placeholder } : base;

  const platformFromHref = (href='') => {
    let path='';
    try { path=new URL(href,location.origin).pathname; } catch(_) { path=String(href).split('?')[0]; }
    const prefix='/pages/compatibilite-airsoft-';
    if(!path.startsWith(prefix)) return '';
    const handle=path.slice(prefix.length).replace(/\/$/,'');
    return PLATFORMS[handle] ? handle : '';
  };

  const detectPlatform = () => {
    const requested=normalize(params.get('aw_platform')||'');
    if(PLATFORMS[requested]) return requested;
    const direct=platformFromHref(location.pathname);
    if(direct) return direct;
    if(!location.pathname.startsWith('/products/') && !location.pathname.startsWith('/pages/compatibilite-airsoft-')) return '';
    for(const link of document.querySelectorAll('a[href*="/pages/compatibilite-airsoft-"]')) {
      const handle=platformFromHref(link.getAttribute('href')||link.href||'');
      if(handle) return handle;
    }
    return '';
  };

  const platformKey=detectPlatform();
  const platform=platformKey ? { key:platformKey, label:PLATFORMS[platformKey][0], aliases:PLATFORMS[platformKey][1], url:`/pages/compatibilite-airsoft-${platformKey}` } : null;
  const activeEyebrow=platform ? `Compatibilité · ${platform.label}` : context.eyebrow;
  const activeTitle=platform ? `Rechercher pour ${platform.label}` : context.title;
  const activePlaceholder=platform ? `Chargeur, pièce, guide ou accessoire pour ${platform.label}…` : context.placeholder;

  const setHidden=(form,name,value)=>{
    if(!form) return;
    let input=form.querySelector(`input[name="${name}"]`);
    if(!value){ input?.remove(); return; }
    if(!input){ input=document.createElement('input'); input.type='hidden'; input.name=name; form.appendChild(input); }
    input.value=value;
  };
  const setInputs=form=>{ setHidden(form,'aw_universe',key==='all'?'':key); setHidden(form,'aw_platform',platformKey); };

  const shortcutRow=()=>{
    if(key==='all'&&!platform) return null;
    const row=document.createElement('div');
    row.className='aw-search-context-shortcuts';
    row.dataset.awSearchContextShortcuts=platformKey||key;
    const label=document.createElement('span');
    label.className='aw-search-context-shortcuts__label';
    label.textContent=platform?`Plateforme · ${platform.label}`:`Univers · ${context.label}`;
    row.appendChild(label);
    if(platform){ const a=document.createElement('a'); a.href=platform.url; a.textContent=`Voir ${platform.label}`; row.appendChild(a); }
    if(key!=='all'){
      const home=document.createElement('a');
      home.href=context.home;
      home.textContent=platform?`Tout ${context.label}`:'Explorer cet univers';
      row.appendChild(home);
      (context.links||[]).slice(0,platform?2:3).forEach(([title,href])=>{ const a=document.createElement('a'); a.href=href; a.textContent=title; row.appendChild(a); });
    }
    return row;
  };

  const personalizeOverlay=()=>{
    const overlay=document.querySelector('[data-search-overlay]');
    if(!overlay) return null;
    const sig=`${key}|${platformKey}`;
    if(overlay.dataset.awContextKey===sig) return overlay;
    overlay.dataset.awContextKey=sig;
    const eyebrow=overlay.querySelector('.search-overlay__eyebrow');
    const title=overlay.querySelector('#SearchOverlayTitle');
    const form=overlay.querySelector('.search-overlay__form');
    const input=overlay.querySelector('[data-search-input]');
    if(eyebrow) eyebrow.textContent=activeEyebrow;
    if(title) title.textContent=activeTitle;
    if(input) input.placeholder=activePlaceholder;
    setInputs(form);
    overlay.querySelector('.aw-search-context-shortcuts')?.remove();
    const row=shortcutRow();
    if(row&&form) form.insertAdjacentElement('afterend',row);
    return overlay;
  };

  const setShortcutHidden=(overlay,hidden)=>{
    const row=overlay?.querySelector('.aw-search-context-shortcuts');
    if(row && row.hidden!==hidden) row.hidden=hidden;
  };

  const textContains=(text,needle)=>{
    const haystack=normalize(text), target=normalize(needle);
    return Boolean(target)&&(haystack===target||haystack.includes(target));
  };

  const platformScore=(text,href='')=>{
    if(!platform) return 0;
    let scoreValue=0;
    const combined=`${text||''} ${href||''}`;
    if(platformFromHref(href)===platformKey) scoreValue+=140;
    if(normalize(href).includes(platformKey)) scoreValue+=80;
    for(const alias of platform.aliases) if(textContains(combined,alias)) scoreValue+=24;
    if(textContains(combined,platform.label)) scoreValue+=40;
    return Math.min(scoreValue,220);
  };

  const score=(text,type='',href='')=>{
    let value=0;
    const haystack=normalize(`${text||''} ${href||''}`);
    if(key!=='all'){
      (context.keywords||[]).forEach(word=>{ if(haystack.includes(normalize(word))) value+=8; });
      if(key==='guides'&&type==='articles') value+=60;
      if(key==='compatibility'&&(type==='pages'||haystack.includes('compatibilite'))) value+=60;
      if(key==='workshop'&&(haystack.includes('atelier')||haystack.includes('forfait'))) value+=45;
      if(key==='assassins-creed'&&haystack.includes('assassin')) value+=45;
      if(key==='parkour'&&haystack.includes('parkour')) value+=45;
      if(key==='youtube'&&(haystack.includes('youtube')||haystack.includes('video'))) value+=45;
    }
    return value+platformScore(text,href);
  };

  const hrefOf=node=>node?.getAttribute?.('href')||node?.querySelector?.('a[href]')?.getAttribute('href')||'';
  const reorder=(list,type)=>{
    if(!list||(key==='all'&&!platform)) return;
    [...list.children]
      .map((node,index)=>({node,index,score:score(node.textContent||'',type,hrefOf(node))}))
      .sort((a,b)=>b.score-a.score||a.index-b.index)
      .forEach(entry=>list.appendChild(entry.node));
  };

  const decoratePredictive=(panel,overlay)=>{
    if(!panel||panel.hidden||(key==='all'&&!platform)){
      setShortcutHidden(overlay,Boolean(panel&&!panel.hidden));
      return;
    }

    const options=[...panel.querySelectorAll('[data-search-option]')];
    const firstHref=options[0]?.getAttribute('href')||'';
    const lastHref=options[options.length-1]?.getAttribute('href')||'';
    const query=overlay?.querySelector('[data-search-input]')?.value||'';
    const sig=`${key}|${platformKey}|${query}|${options.length}|${firstHref}|${lastHref}`;
    if(panel.dataset.awContextSignature===sig){ setShortcutHidden(overlay,true); return; }
    panel.dataset.awContextSignature=sig;

    const grid=panel.querySelector('.predictive-search-premium__grid');
    if(grid){
      const groups={
        products:grid.querySelector('.predictive-search-premium__group--products'),
        collections:grid.querySelector('.predictive-search-premium__group--collections'),
        articles:grid.querySelector('.predictive-search-premium__group--articles'),
        pages:grid.querySelector('.predictive-search-premium__group--pages')
      };
      const order=platform||key==='compatibility'
        ? ['pages','products','collections','articles']
        : key==='guides'
          ? ['articles','pages','products','collections']
          : key==='workshop'
            ? ['products','pages','articles','collections']
            : ['products','collections','articles','pages'];
      order.forEach(name=>groups[name]&&grid.appendChild(groups[name]));
      Object.entries(groups).forEach(([type,group])=>reorder(group?.querySelector('ul'),type));
    }

    const summary=panel.querySelector('.predictive-search-premium__summary');
    if(summary){
      let note=summary.querySelector('.aw-search-context-note');
      if(!note){ note=document.createElement('span'); note.className='aw-search-context-note'; summary.appendChild(note); }
      note.textContent=platform?`Priorité : ${platform.label}`:`Priorité : ${context.label}`;
    }

    const footer=panel.querySelector('#PredictiveSearch-all[href]');
    if(footer){
      const url=new URL(footer.href,location.origin);
      if(key!=='all') url.searchParams.set('aw_universe',key); else url.searchParams.delete('aw_universe');
      if(platformKey) url.searchParams.set('aw_platform',platformKey); else url.searchParams.delete('aw_platform');
      footer.href=url.pathname+url.search;
    }
    setShortcutHidden(overlay,true);
  };

  const watchedOverlays=new WeakSet();
  const watchPredictive=overlay=>{
    if(!overlay||watchedOverlays.has(overlay)) return;
    watchedOverlays.add(overlay);

    let panel=null;
    let overlayObserver=null;
    let panelObserver=null;
    let frame=0;
    let dirty=false;
    let decorating=false;

    const observeOverlay=()=>{
      if(!overlayObserver) return;
      overlayObserver.observe(overlay,{childList:true,subtree:true});
    };
    const observePanel=()=>{
      if(!panelObserver||!panel) return;
      panelObserver.observe(panel,{attributes:true,attributeFilter:['hidden']});
    };

    const run=()=>{
      frame=0;
      if(decorating) return;
      const nextPanel=overlay.querySelector('#PredictiveSearchPremium');
      if(nextPanel!==panel) bindPanel(nextPanel);
      if(!panel){ setShortcutHidden(overlay,false); dirty=false; return; }

      const contentChanged=dirty;
      dirty=false;
      decorating=true;
      overlayObserver?.disconnect();
      panelObserver?.disconnect();
      if(contentChanged) delete panel.dataset.awContextSignature;
      try {
        setShortcutHidden(overlay,!panel.hidden);
        decoratePredictive(panel,overlay);
      } finally {
        decorating=false;
        observeOverlay();
        observePanel();
      }
    };

    const schedule=(contentChanged=false)=>{
      dirty=dirty||contentChanged;
      if(frame) return;
      frame=requestAnimationFrame(run);
    };

    const bindPanel=candidate=>{
      if(candidate===panel) return;
      panelObserver?.disconnect();
      panel=candidate||null;
      if(panel){
        panelObserver=new MutationObserver(()=>schedule(false));
        observePanel();
        delete panel.dataset.awContextSignature;
      }
      setShortcutHidden(overlay,Boolean(panel&&!panel.hidden));
      schedule(true);
    };

    overlayObserver=new MutationObserver(()=>{
      const candidate=overlay.querySelector('#PredictiveSearchPremium');
      if(candidate!==panel) bindPanel(candidate);
      else schedule(true);
    });
    observeOverlay();
    bindPanel(overlay.querySelector('#PredictiveSearchPremium'));
    if(!panel) setShortcutHidden(overlay,false);
  };

  const personalizeSearchPage=()=>{
    const hero=document.querySelector('.search-hero');
    if(!hero||(key==='all'&&!platform)) return;
    const eyebrow=hero.querySelector('.eyebrow');
    const heading=hero.querySelector('h1');
    const form=hero.querySelector('.search-page-form');
    const input=form?.querySelector('input[type="search"]');
    if(eyebrow) eyebrow.textContent=platform?`Recherche contextuelle · ${platform.label}`:'Recherche contextuelle';
    if(heading) heading.textContent=platform?`Rechercher pour ${platform.label}`:`Rechercher dans ${context.label}`;
    if(input) input.placeholder=activePlaceholder;
    setInputs(form);

    let info=hero.querySelector('.aw-search-page-context');
    if(!info&&form){ info=document.createElement('div'); info.className='aw-search-page-context'; form.insertAdjacentElement('afterend',info); }
    if(info){
      info.replaceChildren();
      const label=document.createElement('span'); label.textContent=platform?'Plateforme active :':'Univers actif :';
      const strong=document.createElement('strong'); strong.textContent=platform?platform.label:context.label;
      const link=document.createElement('a');
      const url=new URL(location.href);
      if(platform){ url.searchParams.delete('aw_platform'); link.textContent=`Retirer ${platform.label}`; }
      else { url.searchParams.delete('aw_universe'); link.textContent='Rechercher dans toute la boutique'; }
      link.href=url.pathname+url.search;
      info.append(label,strong,link);
    }

    const head=document.querySelector('.search-results-head');
    if(head){
      let badge=head.querySelector('.aw-context-priority');
      if(!badge){ badge=document.createElement('span'); badge.className='aw-context-priority'; head.firstElementChild?.appendChild(badge); }
      badge.textContent=platform?`Résultats priorisés · ${platform.label}`:`Résultats priorisés · ${context.label}`;
    }

    const grid=document.querySelector('.product-grid[role="list"]');
    if(grid){
      [...grid.children]
        .map((node,index)=>({node,index,score:score(node.textContent||'',normalize(node.querySelector('small')?.textContent||''),hrefOf(node))}))
        .sort((a,b)=>b.score-a.score||a.index-b.index)
        .forEach(entry=>grid.appendChild(entry.node));
    }
  };

  const syncMobile=(attempt=0)=>{
    if(key==='all'&&!platform) return;
    const footer=document.querySelector('.aw-mobile-menu-footer');
    if(!footer){ if(attempt<8) setTimeout(()=>syncMobile(attempt+1),120+attempt*80); return; }
    footer.querySelector('.aw-mobile-menu-context')?.remove();
    footer.querySelector('.aw-mobile-menu-platform-context')?.remove();
    if(platform){
      const link=document.createElement('a');
      link.className='aw-mobile-menu-platform-context';
      link.href=platform.url;
      const span=document.createElement('span'); span.textContent=`Plateforme · ${platform.label}`; link.appendChild(span);
      footer.prepend(link);
    }
    if(key!=='all'){
      const link=document.createElement('a');
      link.className='aw-mobile-menu-context';
      link.href=context.home;
      const span=document.createElement('span'); span.textContent=`Univers · ${context.label}`; link.appendChild(span);
      footer.prepend(link);
    }
  };

  const initOverlay=()=>{
    const overlay=personalizeOverlay();
    watchPredictive(overlay);
  };

  document.querySelector('[data-aw-context-search-open]')?.addEventListener('click',()=>{
    document.querySelector('[data-search-open]')?.click();
    requestAnimationFrame(()=>document.querySelector('[data-search-overlay] [data-search-input]')?.focus());
    window.AWAnalytics?.track?.('context_search_open',{universe:key,platform:platformKey||''});
  });

  document.addEventListener('click',event=>{
    const link=event.target.closest?.('.aw-contextual-universe a,.aw-search-context-shortcuts a,.aw-mobile-menu-context,.aw-mobile-menu-platform-context');
    if(link) window.AWAnalytics?.track?.('context_navigation',{universe:key,platform:platformKey||'',href:link.getAttribute('href')||'',label:(link.textContent||'').trim()});
  },true);

  initOverlay();
  personalizeSearchPage();
  syncMobile();
  document.documentElement.dataset.awUniverse=key;
  if(platformKey) document.documentElement.dataset.awPlatform=platformKey; else delete document.documentElement.dataset.awPlatform;

  window.AWUniverseContext={key,...context,platform:platform||null};
  window.AWPlatformContext=platform;
  window.AWContextualUniverse={version:'2.0.0',key,platform:platformKey||'',refresh:()=>{initOverlay();personalizeSearchPage();syncMobile();}};

  document.addEventListener('shopify:section:load',()=>{
    initOverlay();
    personalizeSearchPage();
    syncMobile();
  });
})();
